import './LoginPage.scss';
import { LoginFormS } from '../../components/LoginSupabase';

export const LoginPage = () => {
  return (
    <div className="loginPage">
      <LoginFormS />
    </div>
  );
};
